import { render } from "./technical-details.vue?vue&type=template&id=1da0e4d8"
import script from "./technical-details.vue?vue&type=script&lang=js"
export * from "./technical-details.vue?vue&type=script&lang=js"

import "./technical-details.vue?vue&type=style&index=0&id=1da0e4d8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__